export default {
    methods: {
        validateField(element) {
            return (!element.$dirty) ? null: element.$dirty && !element.$error;
        },
    }
}